import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { InformationCircleSolidIcon } from '@compono/ui-icons';
import { Text } from '../Text/Text.js';
import { ToggleTipArrow } from './components/ToggleTipArrow.js';
import { ToggleTipBase } from './components/ToggleTipBase.js';
import { ToggleTipIconButton } from './components/ToggleTipIconButton.js';
import { ToggleTipPopover } from './components/ToggleTipPopover.js';
import { ToggleTipCard } from './components/ToggleTipCard.js';

var ToggleTip = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? jsx(InformationCircleSolidIcon, {}) : _b, label = _a.label, width = _a.width, maxWidth = _a.maxWidth, children = _a.children, buttonRef = _a.buttonRef, popoverRef = _a.popoverRef, buttonSx = _a.buttonSx, buttonProps = _a.buttonProps, popoverProps = _a.popoverProps, props = __rest(_a, ["icon", "label", "width", "maxWidth", "children", "buttonRef", "popoverRef", "buttonSx", "buttonProps", "popoverProps"]);
    return (jsxs(ToggleTipBase, __assign({}, props, { children: [jsx(ToggleTipIconButton, __assign({ label: label, ref: buttonRef, sx: buttonSx }, buttonProps, { children: icon })), jsx(ToggleTipPopover, __assign({ width: width, maxWidth: maxWidth, ref: popoverRef }, popoverProps, { children: jsxs(ToggleTipCard, { children: [jsx(Text, __assign({ tone: "light" }, { children: children })), jsx(ToggleTipArrow, {})] }) }))] })));
};

export { ToggleTip };
//# sourceMappingURL=ToggleTip.js.map
